import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import Loader from "@/components/widgets/loader.vue";
import { PAFormQuestionComboModel } from "@/store/models/paForm/paFormQuestionComboDTO";
import { format } from "date-fns";
import { Guid } from "guid-typescript";
import formMachine from "../machines/FormsMachine";
import DeleteComponent from "@/components/deleteComponent.vue";
import FormQuestionComponent from "./FormQuestionComponent.vue";
import { Container } from "vue-smooth-dnd";
import { interpret } from "xstate";
import { v4 as uuidv4 } from "uuid";
import { FormModule } from "@/store/modules/paForm.module";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { toaster } from "@/utilities/toaster";
let FormComponent = /** @class */ (() => {
    var _a;
    let FormComponent = class FormComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.mode = "";
            this.toggleQaMark = false;
            this.newQuestionText = "";
            this.listOrderCounter = 0;
            this.focusState = false;
            this.formCombo = new PAFormQuestionComboModel();
            this.machine = formMachine.withContext({
                formId: Guid.createEmpty(),
                mode: "",
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        createNewQuestion() {
            return {
                id: this.generatedNewGuid(),
                question: this.newQuestionText.trim(),
                listOrder: ++this.listOrderCounter,
                formId: "",
                controlTypeId: "",
                isMandatory: this.toggleQaMark,
                isSaved: false,
            };
        }
        generatedNewGuid() {
            var newGuid = Guid.create();
            return newGuid.toString();
        }
        addQuestion() {
            this.machineService.send({ type: "ADD_QUESTION" });
            if (this.newQuestionText.trim() !== "") {
                const newQuestion = this.createNewQuestion();
                this.formCombo.questions.push(newQuestion);
            }
            this.newQuestionText = "";
            this.toggleQaMark = false;
            this.focusState = false;
        }
        handleDrop({ addedIndex, removedIndex }) {
            const updatedQuestions = [...this.formCombo.questions];
            const [movedQuestion] = updatedQuestions.splice(removedIndex, 1);
            updatedQuestions.splice(addedIndex, 0, movedQuestion);
            updatedQuestions.forEach((question, index) => {
                question.listOrder = index + 1;
            });
            this.formCombo.questions = updatedQuestions;
        }
        closeForm() {
            this.clearForm();
            this.machineService.send({ type: "CANCEL_FORM" });
        }
        clearForm() {
            this.$bvModal.hide("review-form");
            this.resetForm();
        }
        refreshpage() { }
        resetForm() {
            this.formCombo.id = uuidv4();
            this.formCombo.name = "";
            this.formCombo.isArchived = false;
            this.formCombo.questions = [];
        }
        saveForm() {
            this.validate("newFormObserver").then((response) => {
                if (response) {
                    this.formCombo.questions = this.formCombo.questions.map((question, index) => {
                        return { ...question, listOrder: index + 1 };
                    });
                    if (this.mode == "Add") {
                        this.machineService.send({ type: "ADDING_FORM", item: this.formCombo });
                    }
                    else if (this.mode == "Edit") {
                        if (this.formCombo.questions.length > 0) {
                            this.machineService.send({ type: "EDITING_FORM", item: this.formCombo });
                        }
                        else {
                            toaster.ShowError("A Form should have atleast one question.");
                        }
                    }
                }
            });
        }
        deleteQuestionHandler(question) {
            const indexToDelete = this.formCombo.questions.findIndex((q) => q.id === question.id);
            if (indexToDelete !== -1) {
                this.formCombo.questions.splice(indexToDelete, 1);
                for (let i = indexToDelete; i < this.formCombo.questions.length; i++) {
                    this.formCombo.questions[i].listOrder = this.formCombo.questions[i].listOrder - 1;
                }
            }
        }
        duplicateQuestionHandler({ duplicatedQuestion, originalQuestion }) {
            const originalQuestionIndex = this.formCombo.questions.indexOf(originalQuestion);
            duplicatedQuestion.id = this.generatedNewGuid;
            if (originalQuestionIndex !== -1) {
                this.formCombo.questions.splice(originalQuestionIndex + 1, 0, duplicatedQuestion);
                duplicatedQuestion.listOrder = originalQuestion.listOrder + 1;
                for (let i = originalQuestionIndex + 2; i < this.formCombo.questions.length; i++) {
                    this.formCombo.questions[i].listOrder++;
                }
            }
        }
        deleteInputField() {
            this.newQuestionText = "";
            this.machineService.send({ type: "DELETE_QUESTION" });
        }
        get formattedCurrentTime() {
            const currentTime = new Date();
            const formattedTime = format(currentTime, "MMM dd, yyyy, hh:mma");
            return formattedTime;
        }
        get getForm() {
            return FormModule.form;
        }
        get formattedDate() {
            return FormModule.createdOnAsString;
        }
        showModal(mode, formId) {
            this.$bvModal.show("review-form");
            this.mode = mode;
            this.machineService.send({ type: "SHOW_FORM", mode: mode, formId: formId });
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                if (this.previousState.matches("savingForm") && this.state.matches("modalDormant")) {
                    this.clearForm();
                    this.refreshpage();
                }
                if (this.previousState.matches("updatingForm") && this.state.matches("modalDormant")) {
                    this.clearForm();
                    this.refreshpage();
                }
                if (this.previousState.matches("gettingForm") && this.state.matches("loadedForm")) {
                    const { id, name, isArchived, status, hasResponses, createdBy, questions } = this.getForm;
                    Object.assign(this.formCombo, {
                        id,
                        name,
                        isArchived,
                        status,
                        hasResponses,
                        createdBy,
                        questions,
                    });
                }
                // if (this.state.matches("loadedForm") && this.mode != "View") {
                //     this.$nextTick(() => {
                //         this.setFocusToInputAndSelect("addFormFocus");
                //     });
                // }
            });
        }
        addFocus() {
            if (this.mode == "Add") {
                this.setFocusToInput("addFormFocus");
            }
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Guid !== "undefined" && Guid) === "function" ? _a : Object)
    ], FormComponent.prototype, "formId", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormComponent.prototype, "refreshpage", null);
    FormComponent = __decorate([
        Component({
            name: "formComponent",
            components: {
                simplebar,
                DeleteComponent,
                Loader,
                FormQuestionComponent,
                Container,
                SectionLoader,
            },
        })
    ], FormComponent);
    return FormComponent;
})();
export default FormComponent;
